module.exports = __webpack_public_path__ + "img/beaker-02.0795ac04.svg";